module.exports = __webpack_public_path__ + "static/media/internet-of-things02.073a8300.png";